module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_0.2759495d.png";